<template>
  <div>
    <div class="brand_infoBox text-center mt50">
      <h1 class="brand_logo"></h1>
    </div>
    <div class="fullbox" :style="{'width': window.width + 'px', 'height': windowHeight + 'px'}">
      <div class="fullbox_cont">
        <div class="jumbotron cover_bikeData">
          <div class="container-fluid">
            <p class="red"><i class="icon-warning"></i> {{ $t('coverBikeData.title') }}</p>
            <div class="text_btnTextBox">
                <p>{{ $t('coverBikeData.click') }}</p>
                <button class="btn btn_normalBtn" type="button" @click="funcOk">{{ $t('coverBikeData.btnOk') }}</button>
                <p>{{ $t('coverBikeData.replaceData') }}</p>
            </div>
            <div class="text_btnTextBox">
                <p>{{ $t('coverBikeData.click') }}</p>
                <button class="btn btn_normalBtn" type="button" @click="funcCancel">{{ $t('coverBikeData.cancel') }}</button>
                <p>{{ $t('coverBikeData.keepData') }}</p>
            </div>
          </div>
        </div>
        <div class="register_over">
          <i class="icon-reg_bike"></i>
          <p>{{ $t('coverBikeData.tips') }}</p>
        </div>
      </div>
    </div>
    <uiv-modal v-model="modalOpenDisconnect" class="v-modal-style" :backdrop="false">
      <h4 slot="header" class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button
          id="btnOK"
          type="button"
          class="btn btn-default mb20"
          @click="funcOkBtnDialog">{{ modal.btn.ok }}</button>
      </template>
    </uiv-modal>
  </div>
</template>
<script>
import { windowsResize } from '@/mixins/windows-resize';
import { bikeRecheckVINAPI } from '@/mixins/websocket-api';
import * as connectBikeAPI from '@/api/connect-bike';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import { mapGetters } from 'vuex';

export default {
  name: 'CoverBikeData',
  mixins: [bikeRecheckVINAPI, windowsResize],
  data () {
    return {
      modalOpenDisconnect: false,
      modal: {
        data: {
          title: this.$t('bikeOverview.modalTitle'),
          content: ''
        },
        btn: {
          ok: this.$t('bikeOverview.modalBtnOk'),
          cancel: this.$t('bikeOverview.modalBtnCancel')
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      getBikeFrameNo: 'bikeConnect/getBikeFrameNo'
    }),
    windowHeight () {
      let oriHeight = this.window.height;
      if (oriHeight !== null) {
        oriHeight -= 152;
      }
      return oriHeight;
    }
  },
  methods: {
    funcOk () {
      this.$router.push('/writevin');
    },
    funcCancel () {
      this.ws.GetSystemInfo();
    },
    funcOkBtnDialog () {
      this.modalOpenDisconnect = false;
      this.$router.push('/connect');
    },
    async funcBindBikeModel () {
      let bikeFID = { FrameNo: this.getBikeFrameNo };
      const encryptData = funcEncryptData(bikeFID);
      const data = await connectBikeAPI
        .getBikeModel(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      if (data.ErrorCode === 0) {
        this.bikeModel = data.BikeModel;
        this.$store.dispatch('bikeInformation/addBikeModel', this.bikeModel);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fullbox {
  position: relative;
  overflow: hidden;
}
</style>
